import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

export const configJSON = require("./config");

// Customizable Area Start
export interface IChat {
  id: string;
  muted: boolean;
  unreadCount: number;
  lastMessage: string;
  name: string;
}
interface IChatResponse {
  id: string;
  attributes: {
    name: string;
    accounts_chats: [
      {
        id: string;
        attributes: {
          account_id: number;
          muted: boolean;
          unread_count: number;
        };
      }
    ];
    messages: {
      id: string;
      attributes: { id: number; message: string };
      message: string;
    };
  };
}
// Customizable Area End
export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  token: string;
  accountId: number;
  chatName: string;
  chatList: IChat[];
  isVisibleModal: boolean;
  chatMessageVal: string;
  usersChatList: any[];
  backupUsersChatList: any[];
  getChatsList: any[];
  receiverIdChat: string;
  receiverChatObj: any;
  dialogObj: any;
  loginInfo: any;
  selectedFileType: any;
  selectedFileName: any;
  selectedFilePreview: any;
  chatsFilePreview: any;
  fileObj: any;
  filesResult: any;
  logoutFlag: boolean;
  filePreviewUrl: string;
  fileAttachmentArr: any[];
  accordionOpen: boolean;
  isSelectedUser: boolean;
  emailData: string;
  clickedSelectedUser: string;
  fileTypeUpload: string;
  selectedQuickBloxId: string;
  profileImagePic: string;
  patientDataChats: any[];
  isOpenAudioCall: boolean;
  isOpenMic: boolean;
  isUploadDocLoading: boolean;
  iOpenAcceptRejectPage: boolean;
  isShowTyping: boolean;
  isChatOkay: boolean;
  unreadAccordion: boolean;
  sessionState: any
  callingUser: {profile_image: string, name: string}
  patientsIds: number[]
  patientsProfile: any[]
  chatProfile: string | undefined
  isLoading: boolean
  language: string;
  searchText: string;
  firebaseChatId: string;
  railsChatId: string;
  isPatientsLoading: boolean;
  isMessagesLoading: boolean;
  chatLoadError: string;
  receiverQuickBloxId: string;
  // Customizable Area End
}

interface SS {
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

export default class ChatController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  getChatListApiCallId: string = "";
  createChatRoomApiCallId: string = "";
  postMsgPhotoApiCallId:string = "";
  getUserProfileApiCallId: string = "";
  getTrailVisitScheduleCallID: string = "";
  getActiveStudyPatientsApiCallId: string = "";
  markMessagesReadApiCallId: string = "";
  createPatientChatApiCallId: string = "";
  createPatientMessageApiCallId: string = "";
  firebaseTokenApiCallId: string = "";
  chatUnsubscribe: (() => void) | null = null;
  chatListeners: { [firebaseChatId: string]: () => void } = {};
  chatListenerPrimed: { [firebaseChatId: string]: boolean } = {};
  chatMessageCache: { [firebaseChatId: string]: any[] } = {};
  chatInputHeight = "75px";
  bottomSpace = "16px";
  TestData = [
    {
      avatar:
        "https://pbs.twimg.com/profile_images/1498641868397191170/6qW2XkuI_400x400.png",
      name: "John Toretoasdasdas",
      lastMessage: "See you tmr",
      receivedAt: "12:30",
      unreadMessage: 2,
    },
    {
      avatar:
        "https://pbs.twimg.com/profile_images/1498641868397191170/6qW2XkuI_400x400.png",
      name: "John Toreto",
      lastMessage: "See you tmr",
      receivedAt: "12:30",
      unreadMessage: 2,
    },
    {
      avatar: "avatar 1",
      name: "John Toreto",
      lastMessage: "See you tmrr",
      receivedAt: "12:30",
      unreadMessage: 2,
    },
    {
      avatar: "avatar 1",
      name: "John Toreto",
      lastMessage: "See you tmrrrr",
      receivedAt: "12:30",
      unreadMessage: 2,
    },
    {
      avatar: "avatar 1",
      name: "John Toreto",
      lastMessage: "See you sdasd",
      receivedAt: "12:30",
      unreadMessage: 2,
    },
  ];
  Chats = [
    {
      user: 1,
      message: "hello,hellohellohelloheellohellohellohelloddddd",
    },
    {
      user: 2,
      message: "hello 1",
      name: "John Toreto",
    },
  ];

  QB: any = null;
  audioElement = new Audio()


  calleesIds = [139699068, 139699191];

  sessionType = null;
  session: any = {};

  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    this.subScribedMessages = [
      // Customizable Area Start
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.NavigationPayLoadMessage),
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      token: "",
      accountId: -1,
      chatName: "",
      chatList: [],
      isVisibleModal: false,
      chatMessageVal: "",
      usersChatList: [],
      backupUsersChatList:[],
      getChatsList: [],
      receiverIdChat: "",
      receiverChatObj: {},
      dialogObj: {},
      loginInfo: {},
      selectedFileType: "",
      selectedFileName: "",
      selectedFilePreview: "",
      chatsFilePreview: null,
      filesResult: {},
      fileObj: {},
      logoutFlag: false,
      filePreviewUrl: "",
      fileAttachmentArr: [],
      accordionOpen: false,
      isSelectedUser: false,
      emailData: "",
      clickedSelectedUser: "",
      fileTypeUpload: "",
      selectedQuickBloxId: "",
      profileImagePic: "",
      patientDataChats: [],
      isOpenAudioCall: false,
      isOpenMic: false,
      isUploadDocLoading: false,
      iOpenAcceptRejectPage: false,
      isShowTyping: false,
      isChatOkay: false,
      unreadAccordion: false,
      sessionState: {},
      callingUser: {profile_image: "", name: ""},
      patientsIds: [],
      patientsProfile: [],
      chatProfile: "",
      isLoading: false,
      language: localStorage.getItem('language') || 'en',
      searchText: "",
      firebaseChatId: "",
      railsChatId: "",
      isPatientsLoading: false,
      isMessagesLoading: false,
      chatLoadError: "",
      receiverQuickBloxId: "",
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    super.componentDidMount();
    this.getToken();
    if (!this.isPlatformWeb()) {
      this.props.navigation.addListener("willFocus", () => {
        this.getToken();
      });
    }
    if (this.isPlatformWeb()) {
      this.getActiveStudyPatients();
    }
    this.getUserProfile();
    this.callTrailVisitScheduleApi();
    if (!this.isPlatformWeb()) {
      this.getAllMessages();
    }

    if(localStorage.getItem("Iscalling")) {
      this.setState({  isLoading: true })
    }
  }

  async componentWillUnmount() {
    Object.keys(this.chatListeners).forEach((chatId) => {
      this.chatListeners[chatId]();
    });
    this.chatListeners = {};
    this.chatUnsubscribe = null;
    super.componentWillUnmount();
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<S>) {
    if (!this.QB?.webrtc) {
      return;
    }
    this.QB.webrtc.onCallListener = this.handleCallListner
    this.QB.webrtc.onStopCallListener = this.handleCallStopListner
    this.QB.webrtc.onRejectCallListener = this.handleCallRejectListner
    this.QB.webrtc.onRemoteStreamListener = this.handleCallStream
  }

  handleGetUserMedia = (error: any, stream: any) => {
    if (!error) {
      if(localStorage.getItem('Iscalling')) {
      this.setState({ iOpenAcceptRejectPage: false });
      this.userCallBack()
      localStorage.removeItem('Iscalling')
      }
      else {
        this.setState({ iOpenAcceptRejectPage: true });
      }
      if (this.state.isOpenMic === false) {
        this.audioElement.srcObject = null;
        this.audioElement.pause()
      }
    }
  }
  userCallBack = () => {
    const dialogObj = JSON.parse(localStorage.getItem('userDialog') as string)
    this.createDialog(dialogObj, "", "")
    this.handleAcceptCall()
  }

  handleLanguageSwitch = (lang: string) => {
    localStorage.setItem('language', lang)
    this.setState({ language: lang })
  }
  handleCallRejectListner = (session: any, userId: any, extension: Record<string, any>) => { 
    this.setState({
      iOpenAcceptRejectPage: false,
      isOpenAudioCall: false,
    });
   };

  handleCallStopListner = (session: any, userId: any, extension: Record<string, any>) => {
    this.setState({ isOpenAudioCall: false }, () => {
      this.state.sessionState.stop(extension);
    });
  };

  handleCallStream = (session: any, userId:  any, stream: any) => {
    this.audioElement.srcObject = stream;
    this.audioElement.play();
  }

  handleCallListner = (session: any, extension: any) => {
      const mediaParams: any = {
        audio: true,
        video: false,
      };

      this.setState({ sessionState: session, callingUser: extension })
      session?.getUserMedia(mediaParams, this.handleGetUserMedia);
  };

  connectQuickBloxServer = async () => {
    return;
  };

  qbConnect = (error: any, result: any) => {
    if (error) {

      this.setState({ logoutFlag: true });
    }
  };

  handleLogout = () => {
    if (this.state.logoutFlag) {
      localStorage.clear();
      this.props.navigation.navigate("EmailAccountLoginBlock");
    }
  };

  handleCallToReceiver = (error: any) => {
    if (!error) {
      this.QB.webrtc.isExistLiveSessionExceptSessionID(this.session?.ID);
    }
  }

  handleSendAudioCall = (error: any, stream: any) => {
    if (!error) {
      const extension = {
        senderID: this.state.loginInfo?.id,
        userInfo: {
          name: "Site Coordinator",
          profile_image: this.state.profileImagePic
        }
      };
      this.session?.call(extension, this.handleCallToReceiver);
    }
  }

  handleOpenAudioCall = () => {
    return;
  };

  connectToUserChat = () => {
    const userId = localStorage.getItem("userId");
    const chatToken = localStorage.getItem("chatToken");
    const userCredentials = {
      userId: Number(userId),
      password: String(chatToken),
    };
    this.QB.chat?.connect(userCredentials, this.qbConnect);
  };

  getQbMessages = (error: any, messages: any) => {
    if (this.state.firebaseChatId || !messages) {
      return;
    }
    this.setState({ isChatOkay: true, getChatsList: messages?.items });
  };

  getAllMessages = () => {
    const paramsChatReceive = {
      chat_dialog_id: this.state.dialogObj?._id,
      sort_desc: "date_sent",
      limit: 200,
      skip:0,
    };
    this.QB.chat?.message?.list(paramsChatReceive, this.getQbMessages);
  };

  qbDialogCreate = (error: any, dialog: any) => {
    if (dialog) {
      this.setState({ dialogObj: dialog }, () => {
        if (this.QB.chat) {
          this.QB.chat.onMessageListener = this.onMessage.bind(this);
          this.getAllMessages();
          this.getListOfDialog();
        }
        this.getListOfDialog();
        this.setState({ logoutFlag: false });
      });
    }
  };

  createDialog = (user: any, flag: string, profile?: string) => {
    const quickBloxUserId = localStorage.getItem("quickBloxId")    
    const userIdNo: any[] = user?.occupants_ids?.filter(
      (dataId: any) => dataId !== Number(quickBloxUserId)
    );

    this.setState({
      receiverIdChat: userIdNo?.find((val: any) => val),
      receiverChatObj: user,
      clickedSelectedUser: flag,
      selectedQuickBloxId: user._id,
      chatProfile: profile
    });

    const paramsPrivateDilog = {
      type: user.type,
      occupants_ids: userIdNo?.find((val: any) => val),
    };

    this.QB?.chat?.dialog?.create(paramsPrivateDilog, this.qbDialogCreate);
  };

  onMessage(userId: any, message: any) {
    if (message.id) {
      this.setState({ isUploadDocLoading: false });
      this.getAllMessages();
      this.getListOfDialog()
    }
  }

  activeMembersFromPatientData = (dialogs: any[]) => {
    const stored = JSON.parse(localStorage.getItem("patientData") || "{}");
    const attendance = Array.isArray(stored)
      ? stored
      : stored?.attendance_data || [];

    return attendance
      .filter((item: any) => {
        const user = item?.user_data;
        return user?.quickblox_id && user.account_deactivated !== true;
      })
      .map((item: any) => {
        const user = item.user_data;
        const qbId = Number(user.quickblox_id);
        const dialog = (dialogs || []).find((entry: any) =>
          (entry.occupants_ids || []).map(Number).includes(qbId)
        );

        if (dialog) {
          return {
            ...dialog,
            name: user.full_name || dialog.name,
            user_id: qbId,
            patient_id: user.id_number,
            unread_messages_count: dialog.unread_messages_count || 0,
          };
        }

        return {
          _id: `member-${qbId}`,
          name: user.full_name,
          user_id: qbId,
          occupants_ids: [qbId],
          unread_messages_count: 0,
          last_message: "",
          patient_id: user.id_number,
          type: 3,
        };
      });
  };

  getListOfDialog = () => {
    const params = {
      limit: 100,
    };

    const publishMembers = (dialogs: any[]) => {
      const members = this.activeMembersFromPatientData(dialogs);
      const list = members.length ? members : dialogs;
      const quickbloxIds = list.map((member: any) => member.user_id).filter(Boolean);
      if (quickbloxIds.length) {
        this.getPatientsProfile(quickbloxIds);
      }
      this.setState({
        usersChatList: list,
        backupUsersChatList: list,
        unreadAccordion: list.some((member: any) => member.unread_messages_count > 0),
      });
    };

    if (!this?.QB?.chat?.dialog?.list) {
      return;
    }

    this.QB.chat.dialog.list(params, (error: any, dialogs: any) => {
      publishMembers(dialogs?.items || []);
    });
  };
  
  onUnreadChange = () => {
    this.setState({ unreadAccordion: !this.state.unreadAccordion });

  }
  
  handleSendMessage = async () => {
    const { fileObj, chatMessageVal, fileAttachmentArr, dialogObj, receiverIdChat, selectedFileName, fileTypeUpload } = this.state;

    const fileParams = {
        name: fileObj?.name,
        file: fileObj,
        type: fileObj?.type,
        size: fileObj?.size,
        public: false,
    };

    if (chatMessageVal.trim().length === 0 && (!fileObj || !fileObj.name)) {
        return;
    }

    if (this.isPlatformWeb()) {
      if (!this.state.railsChatId) {
        this.showAlert("Alert", "Chat is not available for this patient yet.");
        return;
      }
      this.sendPatientMessage(chatMessageVal.trim());
      return;
    }

    let newFileAttachmentArr = [...fileAttachmentArr];

    if (fileObj && fileObj.name) {
        this.setState({ isUploadDocLoading: true });

        await new Promise((resolve, reject) => {
            this.QB.content?.createAndUpload(fileParams, (error: any, result: any) => {
                if (!error) {
                    this.setState({ filesResult: result });
                    newFileAttachmentArr = [...newFileAttachmentArr, { id: result?.uid, type: fileTypeUpload }];
                    resolve(result);
                } else {
                    this.setState({ isUploadDocLoading: false, selectedFilePreview: "", fileObj: {} });
                    this.showAlert("Alert",JSON.parse(error.message).errors[0]);
                    reject(error);
                }
            });
        });
    }

    const message: any = {
        type: "chat",
        body: chatMessageVal.trim() || selectedFileName,
        extension: {
            save_to_history: 1,
            dialog_id: dialogObj._id,
            attachments: newFileAttachmentArr,
        },
        markable: 1,
    };

    (message as any).id = this.QB.chat?.send(Number(receiverIdChat), message);
    this.onMessage(Number(receiverIdChat), message);

    const payload = {
      message: "You have received message from site coordinator",
      title: "Message Received!",
      type: "privateChat",
      details:JSON.stringify({
        name: "site coordinator",
        profileImage: "",
        chatID: localStorage.getItem("quickBloxId"),
        isCurrentUserIdentityHide: false,
        isOpponentIdentityHide: false
      })
    }
    let pushParameters: any = {
      notification_type: "push",
      user: { ids: [this.state.receiverIdChat] },
      environment: "production",
      message: this.QB.pushnotifications.base64Encode(JSON.stringify(payload))
    };
    
    this.QB.pushnotifications.events.create(pushParameters, function() {});

    const fileUrl = fileObj ? this.QB.content.privateUrl(this.state.filesResult?.uid) : "";
    this.setState({
        chatMessageVal: "",
        fileAttachmentArr: [],
        isUploadDocLoading: false,
        selectedFilePreview: "",
        selectedFileType: "",
        filePreviewUrl: fileUrl || "",
    });
};



  handleKeyDown = (evnt: React.KeyboardEvent<HTMLInputElement>) => {
    if (evnt.keyCode === 13 && this.state.chatMessageVal.length !== 0) {
      this.handleSendMessage();
    }
  };

  attachFile() {
    document.getElementById("fileInput")?.click();
  }

  handleLoadFile = (e: any) => {
    this.setState({ isUploadDocLoading: false })
    if (this.state.selectedFileType?.includes("image")) {
      this.setState({ fileTypeUpload: "image" });
    } else if (this.state.selectedFileType?.includes("pdf")) {
      this.setState({ fileTypeUpload: "pdf" });
    } else if (this.state.selectedFileType?.includes("video")) {
      this.setState({ fileTypeUpload: "video" });
    }
  };

  handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files && event.target.files[0];

    if (file) {
      const fileType = file.type;
      this.setState({
        isUploadDocLoading: true,
        selectedFileType: fileType,
        selectedFileName: file?.name,
      });
      const previewUrl = URL.createObjectURL(file);
      this.setState({ fileObj: file });
      const reader = new FileReader();
      reader.onload = this.handleLoadFile;
      reader.readAsDataURL(file);
      this.setState({ selectedFilePreview: previewUrl });
      
    }
  };

  getToken = () => {
    const message: Message = new Message(
      getName(MessageEnum.SessionRequestMessage)
    );
    this.send(message);
  };

  isStringNullOrBlank = (string: string) => {
    return string === undefined || string === null || string.length === 0;
  };

  showModal = () => {
    this.setState({ isVisibleModal: true });
  };

  hideModal = () => {
    this.setState({ isVisibleModal: false });
  };

  navigateToChatView = (chatId: string) => {
    const message = new Message(getName(MessageEnum.NavigationMessage));
    message.addData(getName(MessageEnum.NavigationTargetMessage), "ChatView");

    message.addData(getName(MessageEnum.NavigationPropsMessage), this.props);

    const raiseMessage: Message = new Message(
      getName(MessageEnum.NavigationPayLoadMessage)
    );
    raiseMessage.addData(getName(MessageEnum.SessionResponseData), {
      chatId: chatId,
    });
    message.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);

    this.send(message);
  };

  getChatList = async (token: string) => {
    const header = {
      "Content-Type": configJSON.apiContentType,
      token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getChatListApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getMyChatsApisEndpoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  createChatRoom = (chatName: string) => {
    if (this.isStringNullOrBlank(chatName)) {
      this.showAlert(
        configJSON.errorTitle,
        configJSON.errorAllFieldsAreMandatory,
        ""
      );
    } else {
      const header = {
        "Content-Type": configJSON.apiContentType,
        token: this.state.token,
        "Access-Control-Allow-Origin": "*",
      };
      const bodyData = {
        name: chatName,
      };
      const requestMessage = new Message(
        getName(MessageEnum.RestAPIRequestMessage)
      );

      this.createChatRoomApiCallId = requestMessage.messageId;

      requestMessage.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        configJSON.createChatRoomApiEndPoint
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify(header)
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        JSON.stringify(bodyData)
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestMethodMessage),
        configJSON.postApiMethod
      );

      runEngine.sendMessage(requestMessage.id, requestMessage);
    }
  };

  inputRoomNameProps = {
    onChangeText: (chatName: string) => {
      this.setState({ chatName });
    },
  };

  btnAddRoomProps = {
    onPress: () => this.createChatRoom(this.state.chatName),
  };

  btnCloseModalProps = {
    onPress: () => this.hideModal(),
  };

  btnShowAddModalProps = {
    onPress: () => {
      this.showModal();
    },
  };

  handleChatNameChange = (chatName: string) => {
    this.setState({ chatName });
  };

  async receive(from: string, message: Message) {
    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    const errorResponse = message.getData(
      getName(MessageEnum.RestAPIResponceErrorMessage)
    );
    if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      apiRequestCallId &&
      apiRequestCallId === this.createPatientChatApiCallId
    ) {
      this.createPatientChatApiCallId = "";
      this.handleCreatePatientChatResponse(responseJson);
      return;
    }
    if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      apiRequestCallId &&
      apiRequestCallId === this.firebaseTokenApiCallId
    ) {
      this.firebaseTokenApiCallId = "";
      this.handleFirebaseTokenResponse(responseJson);
      return;
    }
    if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      apiRequestCallId &&
      apiRequestCallId === this.createPatientMessageApiCallId
    ) {
      this.createPatientMessageApiCallId = "";
      this.handleCreatePatientMessageResponse(responseJson);
      return;
    }
    if (errorResponse) this.parseApiCatchErrorResponse(errorResponse);
    if (responseJson?.errors) this.parseApiErrorResponse(responseJson);

    if (getName(MessageEnum.SessionResponseMessage) === message.id) {
      const token: string = message.getData(
        getName(MessageEnum.SessionResponseToken)
      );
      runEngine.debugLog("TOKEN", token);
      if (token) {
        this.setState({ token }, () => this.getChatList(token));
      }
    }
    if (
      responseJson?.data &&
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      this.getChatListApiCallId.length > 0 &&
      apiRequestCallId === this.getChatListApiCallId
    ) {
      this.getChatListApiCallId = "";
      const chatList = responseJson.data;
      const results = chatList.map((item: IChatResponse) => {
        const findAccountMuteResult = item.attributes.accounts_chats.find(
          (item) => item.attributes.account_id === this.state.accountId
        )?.attributes.muted;
        return {
          id: item.id,
          name: item.attributes.name,
          muted:
            findAccountMuteResult ??
            item.attributes.accounts_chats[0].attributes.muted,
          unreadCount:
            item.attributes.accounts_chats[0].attributes.unread_count,
          lastMessage: item.attributes.messages?.attributes?.message,
        };
      });
      this.setState({
        chatList: results,
      });
    }
    if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      this.createChatRoomApiCallId.length > 0 &&
      apiRequestCallId === this.createChatRoomApiCallId &&
      responseJson
    ) {
      this.createChatRoomApiCallId = "";
      this.hideModal();
      this.getChatList(this.state.token);
    }
    this.handlePatientMessageData(message);
    if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      this.getActiveStudyPatientsApiCallId &&
      apiRequestCallId === this.getActiveStudyPatientsApiCallId
    ) {
      this.getActiveStudyPatientsApiCallId = "";
      this.applyActivePatients(responseJson);
    }
    if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      this.markMessagesReadApiCallId &&
      apiRequestCallId === this.markMessagesReadApiCallId
    ) {
      this.markMessagesReadApiCallId = "";
    }
    if(
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      apiRequestCallId === this.postMsgPhotoApiCallId &&
      responseJson
    ) {
      this.setState({ patientsProfile: responseJson.data})
    }
    if(
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      apiRequestCallId === this.getUserProfileApiCallId &&
      responseJson
    ) {
      this.handleGetProfileDataMessageCall(message, responseJson);
    }
    this.callResponceOfTrailVisitSchedule(message, responseJson);
  }

  handleGetProfileDataMessageCall = (message: any, responseJson: any) => {
    if (
      getName(MessageEnum.RestAPIResponceMessage) === message.id &&
      this.getUserProfileApiCallId &&
      responseJson
    ) {
      this.setState({
        profileImagePic: responseJson?.data?.attributes?.profile_image,
      });
    }
  };

  callResponceOfTrailVisitSchedule = (message: any, data1: any) => {
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id && this.getTrailVisitScheduleCallID && data1) {

      this.setState({ patientDataChats: data1 });
    }
  };

  handleGetPatientData = async (message: Message) => {
    const patientData = await message.getData(
      getName(MessageEnum.PatientMessageData)
    );

    this.setState({
      accordionOpen: patientData?.isOpen,
      isSelectedUser: patientData?.isSelectedUser,
      emailData: patientData?.email,
    });
  };

  handlePatientMessageData = (message: Message) => {
    if (getName(MessageEnum.NavigationPayLoadMessage)) {
      if (message.getData(getName(MessageEnum.PatientMessageData))) {
        this.handleGetPatientData(message);
      }
    }
  };

  handleChatMessageChange = (evnt: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = evnt.target.value;
      this.setState({ chatMessageVal: newValue });
  }

  handleChangeAccordionOpen = (
    event: React.ChangeEvent<{}>,
    newExpanded: boolean
  ) => {
    this.setState({ accordionOpen: newExpanded ? true : false });
  };

  getPatientsProfile = async (id:any) => {
    let token = localStorage.getItem("token");
      const header = {
        token: token,
      };

      const formData = new FormData();
      formData.append("quickblox_ids", id);
      const requestMessage = new Message(
        getName(MessageEnum.RestAPIRequestMessage)
      );

      this.postMsgPhotoApiCallId = requestMessage.messageId;

      requestMessage.addData(
        getName(MessageEnum.RestAPIResponceEndPointMessage),
        configJSON.postMsgPhoto
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestMethodMessage),
        configJSON.postApiMethod
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestHeaderMessage),
        JSON.stringify(header)
      );
      requestMessage.addData(
        getName(MessageEnum.RestAPIRequestBodyMessage),
        formData
      );

      runEngine.sendMessage(requestMessage.id, requestMessage);
    }

  getUserProfile = () => {
    let token = localStorage.getItem("token");
    const header = {
      "Content-Type": configJSON.apiContentType,
      token: token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getUserProfileApiCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.getUserAccountApiEndPoint
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  callTrailVisitScheduleApi = async () => {
    const studyId = localStorage.getItem("studyId");

    let token = localStorage.getItem("token");
    const header = {
      "Content-Type": configJSON.apiContentType,
      token: token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.getVisitScheduleAPiEndPoint}/${JSON.parse(String(studyId))}`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );
    this.getTrailVisitScheduleCallID = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  handleRespMicOff = (error: any, stream: any) => {
    if (!error) {
      this.audioElement.srcObject = null;
      this.audioElement.pause();
    }
  }
  handleMicOff = () => {
    this.setState({ isOpenMic: false });

    const mediaParams: any = {
      audio: true,
      video: true,
      options: {
        muted: true,
        mirror: false,
      },
    };
    this.session?.getUserMedia(mediaParams, this.handleRespMicOff);
  };

  handleRespMicOn = (error: any, stream: any) => {
    if (!error) {
      if (this.state.isOpenMic === true) {
        this.audioElement.srcObject = stream;
        this.audioElement.play();
      }
    }
  }

  handleMicOn = () => {
    this.setState({ isOpenMic: true });
    const mediaParams: any = {
      audio: true,
      video: true,
      options: {
        muted: false,
        mirror: false,
      },
    };
    this.session?.getUserMedia(mediaParams, this.handleRespMicOn);
  };

  handleLeaveCall = () => {
    this.setState({ isOpenAudioCall: false }, () => {
      const extension = {};
      this.state.sessionState.stop(extension);
    });
  };

  handleAcceptCallListener = (
    session: any,
    userId: any,
    extension: any
  ) => {
    const mediaParams: any = {
      audio: true,
      video: false,
      options: {
        muted: true,
        mirror: false,
      },
      elemId: "localVideoElem",
    };
    session?.getUserMedia(mediaParams, (error: any, stream: any) => {
      if (!error) {
        session?.accept(extension);
        session?.attachMediaStream("localVideoElem", stream);
      }
    });
  };

  handleAcceptCall = () => {
    this.setState({ iOpenAcceptRejectPage: false, isOpenAudioCall: true, isLoading: false });
    this.state.sessionState.accept({})
    if (this.QB?.webrtc) {
      this.QB.webrtc.onAcceptCallListener = this.handleAcceptCallListener
    }
  };

  handleRejectCallListner = (
    session: any,
    userId: any,
    extension: any
  ) => {
    const mediaParams: any = {
      audio: true,
      video: true,
      options: {
        muted: true,
        mirror: false,
      },
    };
    session?.getUserMedia(mediaParams, (error: any, stream: any) => {
      if (!error) {
        session?.reject(extension);

        session?.attachMediaStream("localVideoElem", stream);

        this.audioElement.pause();
      }
    });
  };

  handleRejectCall = () => {
    this.setState({
      iOpenAcceptRejectPage: false,
      isOpenAudioCall: false,
    });
    this.state.sessionState?.reject({})
  };
  
  getActiveStudyPatients = () => {
    const studyId = localStorage.getItem("studyId");
    if (!studyId) {
      this.setState({
        usersChatList: [],
        backupUsersChatList: [],
        isPatientsLoading: false,
      });
      return;
    }

    let parsedStudyId: string | number = studyId;
    try {
      parsedStudyId = JSON.parse(String(studyId));
    } catch (error) {
      parsedStudyId = studyId;
    }

    const token = localStorage.getItem("token");
    const header = {
      "Content-Type": configJSON.apiContentType,
      token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getActiveStudyPatientsApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.getActiveStudyPatientsEndPoint}${parsedStudyId}/active_study_patients`
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );
    this.setState({ isPatientsLoading: true });
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  extractPatientRecords = (responseJson: any): any[] => {
    if (!responseJson) return [];
    if (Array.isArray(responseJson)) return responseJson;
    const data = responseJson.data ?? responseJson;
    if (Array.isArray(data)) return data;
    const nested =
      data?.active_study_patients ||
      data?.patients ||
      data?.study_patients ||
      responseJson.active_study_patients ||
      responseJson.patients ||
      data?.attributes?.active_study_patients ||
      data?.attributes?.patients;
    if (Array.isArray(nested)) return nested;
    if (data && (data.id || data.attributes || data.user_data)) return [data];
    return [];
  };

  readNamedValue = (source: any, keys: string[]) => {
    if (!source || typeof source !== "object") return "";
    for (const key of keys) {
      const value = source[key];
      if (value !== undefined && value !== null && value !== "" && typeof value !== "object") {
        return value;
      }
    }
    return "";
  };

  readFirebaseValue = (source: any) => {
    const named = this.readNamedValue(source, [
      "firebase_chat_id",
      "firebaseChatId",
      "firestore_chat_id",
      "chat_firebase_id",
      "firebase_id",
    ]);
    if (named) return named;
    if (!source || typeof source !== "object") return "";
    const firebaseKey = Object.keys(source).find((key) => {
      const normalized = key.toLowerCase();
      return (
        normalized.includes("firebase") &&
        source[key] !== undefined &&
        source[key] !== null &&
        source[key] !== ""
      );
    });
    if (!firebaseKey) return "";
    const value = source[firebaseKey];
    if (typeof value !== "object") return value;
    return (
      value.id ||
      value.chat_id ||
      value.firebase_chat_id ||
      value.firebaseChatId ||
      ""
    );
  };

  readChatMeta = (source: any, included: any[] = []) => {
    const layers = [
      source,
      source?.attributes,
      source?.user_data,
      source?.attributes?.user_data,
      source?.chat,
      source?.attributes?.chat,
      source?.chat?.attributes,
      source?.attributes?.chat?.attributes,
    ];
    let firebaseChatId = "";
    let railsChatId = "";
    layers.forEach((layer) => {
      if (!firebaseChatId) {
        firebaseChatId = String(this.readFirebaseValue(layer) || "");
      }
      if (!railsChatId) {
        railsChatId = String(
          this.readNamedValue(layer, [
            "rails_chat_id",
            "railsChatId",
            "chat_id",
          ]) || ""
        );
      }
    });

    const relatedChatId =
      source?.relationships?.chat?.data?.id ||
      source?.attributes?.relationships?.chat?.data?.id;
    if (relatedChatId && included.length) {
      const includedChat = included.find(
        (entry) => String(entry.id) === String(relatedChatId)
      );
      if (!firebaseChatId) {
        firebaseChatId = String(this.readFirebaseValue(includedChat?.attributes) || "");
      }
      if (!railsChatId) {
        railsChatId = String(includedChat?.id || "");
      }
    }

    return { firebaseChatId, railsChatId };
  };

  mapActivePatient = (item: any, included: any[] = []) => {
    const attrs = item?.attributes || item?.user_data || item || {};
    const user = attrs.user_data || attrs;
    if (user.account_deactivated === true || attrs.account_deactivated === true) {
      return null;
    }
    const accountId = this.patientAccountId({
      account_id:
        user.account_id ||
        attrs.account_id ||
        user.account?.id ||
        attrs.account?.id ||
        item?.relationships?.account?.data?.id,
      user_id: user.user_id || attrs.user_id || user.user?.id || attrs.user?.id,
      id: user.id || attrs.id || item?.id,
      patient_id: item?.patient_id || attrs.patient_id || user.patient_id,
    });
    const chatMeta = this.readChatMeta(item, included);
    const patientId =
      user.id_number ||
      user.patient_id ||
      attrs.id_number ||
      attrs.patient_id ||
      "";
    const name = patientId
      ? String(patientId)
      : user.patient_name ||
        attrs.patient_name ||
        user.full_name ||
        user.name ||
        attrs.full_name ||
        attrs.name ||
        `${user.first_name || attrs.first_name || ""} ${user.last_name || attrs.last_name || ""}`.trim() ||
        user.email ||
        attrs.email ||
        "Patient";
    const profile =
      user.profile_image ||
      user.image ||
      attrs.profile_image ||
      attrs.image ||
      "";
    const quickbloxId = user.quickblox_id || attrs.quickblox_id || "";

    return {
      _id: accountId,
      name,
      full_name: name,
      user_id: accountId,
      account_id: accountId,
      patient_id: patientId,
      profile_image: profile,
      quickblox_id: quickbloxId,
      firebase_chat_id: chatMeta.firebaseChatId,
      rails_chat_id: chatMeta.railsChatId,
      unread_messages_count: Number(
        user.unread_count ||
          user.unread_messages_count ||
          attrs.unread_count ||
          attrs.unread_messages_count ||
          0
      ),
      last_message: user.last_message || attrs.last_message || "",
      type: 3,
      occupants_ids: [accountId],
    };
  };

  applyActivePatients = (responseJson: any) => {
    const included = responseJson?.included || [];
    const records = this.extractPatientRecords(responseJson);
    const patients = records
      .map((item: any) => this.mapActivePatient(item, included))
      .filter(Boolean);

    this.setState({
      usersChatList: patients,
      backupUsersChatList: patients,
      isPatientsLoading: false,
      patientsProfile: patients.map((patient: any) => ({
        attributes: {
          profile_image: patient.profile_image,
          quickblox_id: patient.user_id,
        },
      })),
    });
  };

  patientAccountId = (user: any) => {
    const candidates = [
      user?.account_id,
      user?.user_id,
      user?.id,
      user?.patient_id,
      user?.account?.id,
      user?.user?.id,
      user?._id,
    ];
    const found = candidates.find((value) => {
      if (value === undefined || value === null || value === "") return false;
      const text = String(value);
      return text !== "undefined" && text !== "null" && !text.startsWith("member-");
    });
    return found ? String(found) : "";
  };

  openPatientChat = (user: any, flag: string, profile?: string) => {
    const accountId = this.patientAccountId(user);
    this.setPatientUnread(accountId, 0);
    this.setState({
      receiverIdChat: accountId,
      receiverQuickBloxId: user?.quickblox_id ? String(user.quickblox_id) : "",
      receiverChatObj: user,
      clickedSelectedUser: flag,
      selectedQuickBloxId: String(user?._id || flag || ""),
      chatProfile: profile || user?.profile_image || "",
      firebaseChatId: "",
      railsChatId: "",
      getChatsList: [],
      chatLoadError: accountId ? "" : "Chat is not available for this patient yet.",
      isChatOkay: true,
      isMessagesLoading: Boolean(accountId),
    });
    if (accountId) {
      this.createPatientChat(accountId);
    }
  };

  createPatientChat = (accountId: string) => {
    const token = localStorage.getItem("token");
    const header = {
      "Content-Type": configJSON.apiContentType,
      token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.createPatientChatApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.createPatientChatEndPoint || "bx_block_blogpostsmanagement/community_chats/create_chat"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({
        chat_account_id: Number(accountId),
      })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.postApiMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  fetchFirebaseToken = () => {
    const token = localStorage.getItem("token");
    const header = {
      "Content-Type": configJSON.apiContentType,
      token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.firebaseTokenApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.firebaseTokenEndPoint || "bx_block_chat/firebase/token"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.getApiMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  sendPatientMessage = (text: string) => {
    const token = localStorage.getItem("token");
    const header = {
      "Content-Type": configJSON.apiContentType,
      token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.createPatientMessageApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.createPatientMessageEndPoint || "bx_block_blogpostsmanagement/community_chats/create_message"
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({
        chat_id: this.state.railsChatId,
        message: { message: text },
      })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.postApiMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  apiErrorText = (responseJson: any) => {
    const errors = responseJson?.errors;
    if (!errors) return responseJson?.message || responseJson?.meta?.message || "";
    if (typeof errors === "string") return errors;
    if (Array.isArray(errors)) return errors.map((item) => String(item)).join(", ");
    if (typeof errors === "object") {
      if (typeof errors.message === "string") return errors.message;
      const first = Object.values(errors)[0];
      if (Array.isArray(first)) return String(first[0] || "");
      if (first != null) return String(first);
    }
    return "";
  };

  readCreatedChat = (responseJson: any) => {
    const layers = [
      responseJson,
      responseJson?.data,
      responseJson?.data?.attributes,
      responseJson?.chat,
      responseJson?.chat?.attributes,
      responseJson?.data?.chat,
      responseJson?.data?.chat?.attributes,
    ];
    let chatId = "";
    let firebaseChatId = "";
    layers.forEach((layer) => {
      if (!chatId) {
        chatId = String(this.readNamedValue(layer, ["chat_id", "rails_chat_id"]) || "");
      }
      if (!firebaseChatId) {
        firebaseChatId = String(this.readFirebaseValue(layer) || "");
      }
    });
    if (!chatId) {
      chatId = String(
        responseJson?.data?.id ||
          responseJson?.chat?.id ||
          responseJson?.id ||
          ""
      );
    }
    return { chatId, firebaseChatId };
  };

  readFirebaseAuthToken = (responseJson: any) => {
    if (typeof responseJson === "string") return responseJson;
    if (typeof responseJson?.data === "string") return responseJson.data;
    const layers = [
      responseJson,
      responseJson?.data,
      responseJson?.data?.attributes,
      responseJson?.meta,
    ];
    for (const layer of layers) {
      const token = this.readNamedValue(layer, [
        "token",
        "firebase_token",
        "custom_token",
        "access_token",
      ]);
      if (token) return String(token);
    }
    return "";
  };

  handleCreatePatientChatResponse = (responseJson: any) => {
    const errorText = this.apiErrorText(responseJson);
    const { chatId, firebaseChatId } = this.readCreatedChat(responseJson);
    if (!responseJson || responseJson.errors || !chatId || !firebaseChatId) {
      this.setState({
        isMessagesLoading: false,
        isChatOkay: true,
        chatLoadError: errorText || "Unable to open chat.",
      });
      return;
    }
    this.setState(
      (prevState) => ({
        railsChatId: chatId,
        firebaseChatId,
        usersChatList: this.stampPatientChat(
          prevState.usersChatList,
          prevState.receiverIdChat,
          firebaseChatId,
          chatId
        ),
        backupUsersChatList: this.stampPatientChat(
          prevState.backupUsersChatList,
          prevState.receiverIdChat,
          firebaseChatId,
          chatId
        ),
      }),
      () => this.fetchFirebaseToken()
    );
  };

  stampPatientChat = (
    list: any[],
    accountId: string,
    firebaseChatId: string,
    railsChatId: string
  ) => {
    return (list || []).map((patient) => {
      const samePatient =
        String(patient?.account_id || patient?._id || patient?.user_id || "") ===
        String(accountId || "");
      if (!samePatient) return patient;
      return {
        ...patient,
        firebase_chat_id: firebaseChatId,
        rails_chat_id: railsChatId,
        unread_messages_count: 0,
      };
    });
  };

  updatePatientRows = (matcher: (patient: any) => boolean, patch: (patient: any) => any) => {
    const apply = (list: any[]) =>
      (list || []).map((patient) => (matcher(patient) ? patch(patient) : patient));
    this.setState((prevState) => ({
      usersChatList: apply(prevState.usersChatList),
      backupUsersChatList: apply(prevState.backupUsersChatList),
    }));
  };

  setPatientUnread = (accountId: string, count: number) => {
    if (!accountId) return;
    this.updatePatientRows(
      (patient) =>
        String(patient?.account_id || patient?._id || patient?.user_id || "") ===
        String(accountId),
      (patient) => ({ ...patient, unread_messages_count: count })
    );
  };

  bumpUnread = (firebaseChatId: string, count: number, lastMessage?: string) => {
    if (!firebaseChatId || count < 1) return;
    this.updatePatientRows(
      (patient) => String(patient?.firebase_chat_id || "") === String(firebaseChatId),
      (patient) => ({
        ...patient,
        unread_messages_count: Number(patient?.unread_messages_count || 0) + count,
        last_message: lastMessage || patient?.last_message || "",
      })
    );
  };

  sameAccount = (left: string, right: string) => {
    const normalize = (value: string) => String(value || "").replace(/^account_/, "");
    return Boolean(normalize(left)) && normalize(left) === normalize(right);
  };

  handleFirebaseTokenResponse = async (responseJson: any) => {
    const token = this.readFirebaseAuthToken(responseJson);
    if (!responseJson || responseJson.errors || !token || !this.state.firebaseChatId) {
      this.setState({
        isMessagesLoading: false,
        isChatOkay: true,
        chatLoadError: this.apiErrorText(responseJson) || "Unable to connect to Firebase chat.",
      });
      return;
    }
    try {
      const firebase = this.getFirebaseApp();
      require("firebase/auth");
      await firebase.auth().signInWithCustomToken(token);
      this.listenToFirebaseMessages(this.state.firebaseChatId);
    } catch (error) {
      this.setState({
        isMessagesLoading: false,
        isChatOkay: true,
        chatLoadError: "Unable to connect to Firebase chat.",
      });
    }
  };

  handleCreatePatientMessageResponse = (responseJson: any) => {
    if (!responseJson || responseJson.errors) {
      this.showAlert(
        "Alert",
        this.apiErrorText(responseJson) || "Unable to send message. Please try again."
      );
      return;
    }
    this.setState({
      chatMessageVal: "",
      fileAttachmentArr: [],
      isUploadDocLoading: false,
      selectedFilePreview: "",
      selectedFileType: "",
      fileObj: {},
      selectedFileName: "",
    });
  };

  getFirebaseApp = () => {
    const firebase = require("firebase/app");
    require("firebase/auth");
    require("firebase/firestore");
    require("firebase/storage");
    if (!firebase.apps.length) {
      try {
        firebase.initializeApp({
          apiKey: "AIzaSyBe3YSP0FdEknT9s5RA2dmLT_9563egUKI",
          authDomain: "medical-2f3fc.firebaseapp.com",
          projectId: "medical-2f3fc",
          storageBucket: "medical-2f3fc.firebasestorage.app",
          messagingSenderId: "286877870670",
          appId: "1:286877870670:web:e28ff5696f6ecaaf5cf11f",
          measurementId: "G-2W8F4D7M6L",
        });
      } catch (error) {
        if (!firebase.apps.length) {
          throw error;
        }
      }
    }
    return firebase;
  };

  toMessageDate = (value: any) => {
    if (!value) return new Date().toISOString();
    if (typeof value?.toDate === "function") return value.toDate().toISOString();
    if (value?.seconds) return new Date(value.seconds * 1000).toISOString();
    return value;
  };

  listenToFirebaseMessages = (firebaseChatId: string) => {
    if (this.chatListeners[firebaseChatId]) {
      const cached = this.chatMessageCache[firebaseChatId];
      if (cached) {
        this.setState({
          getChatsList: cached,
          chatLoadError: "",
          isChatOkay: true,
          isMessagesLoading: false,
        });
      }
      return;
    }
    try {
      const firebase = this.getFirebaseApp();
      const unsubscribe = firebase
        .firestore()
        .collection("chats")
        .doc(firebaseChatId)
        .collection("messages")
        .onSnapshot(
          (snapshot: any) => {
            const currentUserId = String(
              localStorage.getItem("currentUserId") ||
                localStorage.getItem("userUniqnueId") ||
                ""
            );
            const patientId = String(this.state.receiverIdChat || "");
            const messages = snapshot.docs.map((doc: any) => {
              const data = doc.data() || {};
              const senderId = String(
                data.sender_id ?? data.senderId ?? data.user_id ?? ""
              );
              const recipientId =
                data.recipient_id ??
                data.recipientId ??
                (senderId && this.sameAccount(senderId, currentUserId)
                  ? patientId
                  : currentUserId);
              return {
                id: doc.id,
                ...data,
                message: data.message ?? data.text ?? data.body ?? data.content ?? "",
                sender_id: senderId,
                recipient_id: String(recipientId ?? ""),
                created_at: this.toMessageDate(
                  data.created_at || data.createdAt || data.timestamp
                ),
                attachments: data.attachments || [],
              };
            });
            messages.sort(
              (a: any, b: any) =>
                new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
            );
            this.chatMessageCache[firebaseChatId] = messages;
            const isActive = this.state.firebaseChatId === firebaseChatId;
            if (isActive) {
              this.setState({
                getChatsList: messages,
                chatLoadError: "",
                isChatOkay: true,
                isMessagesLoading: false,
              });
            }
            const primed = this.chatListenerPrimed[firebaseChatId];
            this.chatListenerPrimed[firebaseChatId] = true;
            if (!primed) return;
            const incoming = snapshot.docChanges().filter((change: any) => {
              if (change.type !== "added") return false;
              const data = change.doc.data() || {};
              const senderId = String(
                data.sender_id ??
                  data.senderId ??
                  data.account_id ??
                  data.user_id ??
                  data.from_id ??
                  ""
              );
              return !senderId || !this.sameAccount(senderId, currentUserId);
            });
            if (!incoming.length) return;
            const latest = incoming[incoming.length - 1].doc.data() || {};
            this.bumpUnread(
              firebaseChatId,
              incoming.length,
              latest.message || latest.text || latest.body || latest.content || ""
            );
          },
          (error: any) => {
            if (this.state.firebaseChatId !== firebaseChatId) return;
            this.setState({
              isMessagesLoading: false,
              isChatOkay: true,
              chatLoadError: error?.message || "Unable to load messages.",
            });
          }
        );
      this.chatListeners[firebaseChatId] = unsubscribe;
      this.chatUnsubscribe = unsubscribe;
    } catch (error) {
      this.setState({
        isMessagesLoading: false,
        isChatOkay: true,
        chatLoadError: "Unable to connect to Firebase chat.",
      });
    }
  };

  markMessagesRead = (railsChatId: string) => {
    if (!railsChatId) return;
    const token = localStorage.getItem("token");
    const header = {
      "Content-Type": configJSON.apiContentType,
      token,
    };
    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.markMessagesReadApiCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.updateReadMessageApiEndPoint
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({ chat_id: railsChatId })
    );
    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.putApiMethod
    );
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  sendFirebaseMessage = async () => {
    const { chatMessageVal, firebaseChatId, receiverIdChat } = this.state;
    const text = chatMessageVal.trim();
    if (!firebaseChatId || !text) return;

    try {
      const firebase = this.getFirebaseApp();
      const senderId = String(
        localStorage.getItem("currentUserId") ||
          localStorage.getItem("userUniqnueId") ||
          ""
      );
      await firebase
        .firestore()
        .collection("chats")
        .doc(firebaseChatId)
        .collection("messages")
        .add({
          message: text,
          sender_id: senderId,
          recipient_id: String(receiverIdChat || ""),
          created_at: firebase.firestore.FieldValue.serverTimestamp(),
          attachments: [],
        });

      this.setState({
        chatMessageVal: "",
        fileAttachmentArr: [],
        isUploadDocLoading: false,
        selectedFilePreview: "",
        selectedFileType: "",
        fileObj: {},
        selectedFileName: "",
      });
    } catch (error) {
      this.setState({ isUploadDocLoading: false });
      this.showAlert("Alert", "Unable to send message. Please try again.");
    }
  };

  handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = event?.target?.value?.toLowerCase();
    this.setState({ searchText }, () => {
      const filteredList = this.state.backupUsersChatList.filter((chat) =>
        chat.full_name?.toLowerCase().includes(searchText) ||
        chat.name?.toLowerCase().includes(searchText) ||
        String(chat.patient_id || "").toLowerCase().includes(searchText)
      );
      if(searchText.length === 0) {
        this.setState({ usersChatList: this.state.backupUsersChatList });
      } else {
        this.setState({ usersChatList: filteredList });
      }
    });
  };
  // Customizable Area End
}
